import { render } from "./Tags.vue?vue&type=template&id=e8996530&bindings={\"search\":\"data\",\"searched\":\"data\",\"trends\":\"data\",\"toots\":\"data\",\"tootsCount\":\"data\",\"isLoading\":\"data\",\"handleTagSeach\":\"options\",\"mastodonTagSearch\":\"options\",\"addTagToSearchedList\":\"options\",\"mastodonTrendingTags\":\"options\"}"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script